import PrivateAPIResource from "../../services/PrivateAPIResource";
import * as types from '../actionTypes';

function loadDepartmentsSuccess(departments) {
    return {type: types.LOAD_DEPARTMENTS_SUCCESS, departments};
}

function getDepartmentSuccess(department) {
    return {type: types.GET_DEPARTMENT_SUCCESS, department};
}

function createDepartmentSuccess(department) {
    return {type: types.CREATE_DEPARTMENT_SUCESSS, department};
}

function updateDepartmentSuccess(department) {
    return {type: types.UPDATE_DEPARTMENT_SUCCESS, department};
}

function deleteDepartmentSuccess(id) {
    return {type: types.DELETE_DEPARTMENT_SUCCESS, id};
}

export function loadDepartments(page, sortParams) {
    return function (dispatch) {
        return PrivateAPIResource.all(`departments?page=${page}`, sortParams)
            .then((data) => {
                dispatch(loadDepartmentsSuccess(data));
            })
            .catch(err => {
                throw  err;
            });
    }
}

export function getDepartment(id) {
    return function (dispatch) {
        return PrivateAPIResource.get('departments', id).then(data => {
            dispatch(getDepartmentSuccess(data));
        }).catch(err => {
            throw  err;
        });
    }
}

export function createDepartment(data) {
    return function (dispatch) {
        return PrivateAPIResource.create('departments', data).then(department => {
            dispatch(createDepartmentSuccess(department));
        }).catch(err => {
            throw  err;
        });
    }
}

export function updateDepartment(id, data) {
    return function (dispatch) {
        return PrivateAPIResource.update('departments', id, data).then(department => {
            dispatch(updateDepartmentSuccess(department));
        }).catch(err => {
            throw  err;
        });
    }
}

export function deleteDepartment(id) {
    return function (dispatch) {
        return PrivateAPIResource.remove('departments', id).then(data => {
            dispatch(deleteDepartmentSuccess(id));
        }).catch(err => {
            throw  err;
        });
    }
}


// WEBPACK FOOTER //
// ./web/src/actions/portal-contact/departmentsActions.js